import React, { Component } from 'react';
import { Table, Row, InputNumber, Input, Col, Button, DatePicker, message, Spin } from 'antd';
import moment from 'moment';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
const { MonthPicker } = DatePicker;
const { TextArea } = Input;
Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

const numConvert = (num = 0) => {
    num = Number(num || "0")
    return num
};

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [{
                'comments': ''
            }],
            loading: false,
            print: false
        }
    }


    componentDidMount() {
        this.setState({ loading: true });
        this.getTable3_1_7(this.state.date);
    }
    getTable3_1_7 = (date) => {
        fetch(`/_3_1_7_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                this.setState({
                    data: x.data,
                });
            }
            this.setState({ loading: false });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }
    // 保存
    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map((x) => ({ ...x, year, month }));
        let dataFrom = new FormData();
        // console.log(data)
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_3_1_7', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable3_1_7(this.state.date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table3_1_7', 1.5, '4.65', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { loading, data, date, print, loadingSave } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="table">
                    <Row className="title" id="table3_1_7">
                        <Row className="vice-title">4.6.5 Please critique if the RGI Index is not 1, and the actions. 若收益指数不为1，请阐释，并提供行动计划。</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(date, 'YYYY-MM')}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [{ 'comments': '' }],
                                        loading: true
                                    });
                                    this.getTable3_1_7(str)
                                }}
                            />
                        </Row>
                        <TextArea
                            style={{ marginTop: 10 }}
                            autosize={{ minRows: 4 }}
                            value={data[0] ? data[0]['comments'] : ''}
                            onChange={(e) => {
                                let newdata = [...data];
                                newdata[0]['comments'] = e.target.value;
                                this.setState({
                                    data: newdata
                                })
                            }}

                        />
                    </Row>
                    <Auth loading={loading} auth="edit_3_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/3.0/3-1/3-1-7/index.js